export default __webpack_public_path__ + "img/Montserrat-Medium_418e43d.eot";